<section class="card-section">
  <div class="container p-0">
    <!-- vh-100 -->
    <div class="">
      <!-- align-items-center justify-content-center h-100 w-100 m-0 overflow-hidden -->
      <div class="col-xxl-4 col-lg-5 col-md-6 col-sm-8 col-12 p-0 m-auto">
        <div class="d-flex align-items-center justify-content-center vh-100 coverflow-hidden">
          <div class="card">
            <!-- style="width: 18rem;" -->
            <img src="{{baseURl}}images/pixtar-white-logo.svg" class="card-logo" alt="Creative agency Dubai pixtar" width="" height="" loading="lazy">
            <img src="{{baseURl}}images/junaid.jpg" class="card-img-top" alt="Branding agency in Dubai " width="" height="" loading="lazy">
            <div class="card-body d-flex flex-column justify-content-center">
              <div class="profile-name text-center">
                <h4>Junaid Shaikh</h4>
                <p class="">Co-founder & Brand Director </p>
              </div>

              <div class="account-block">
                <div class="row justify-content-center">
                  <div class="col-sm-10 0ffset-2 col-8 offset-2">
                    <div class="row mb-2">
                      <div class="col-2 p-0 text-center ph"> <a href="tel:971529997111"> <img src="{{baseURl}}images/phone.svg" alt="web designing agency dubai" width="" height="" loading="lazy"> </a></div>
                      <div class="col-10"> <a href="tel:971529997111"> <span>+971 52 999 7111</span></a> </div>
                    </div>
                    <div class="row">
                      <div class="col-2 p-0 text-center em"> <a href="mailto:junaid@pixtar.ae" target="_blank"><img src="{{baseURl}}images/email.svg" alt="website development company dubai" width="" height="" loading="lazy"> </a></div>
                      <div class="col-10"> <a href="mailto:junaid@pixtar.ae" target="_blank">
                          <span>junaid@pixtar.ae</span></a> </div>
                    </div>
                  </div>
                  <!-- <li> <a href="#"><i class="fa fa-envelope" aria-hidden="true"></i> <span>Junaid@pixtar.com</span></a> </li> -->
                </div>
              </div>
              <div class="social-links">
                <div class="d-flex flex-row justify-content-center contact ">
                  <a href="{{baseURl}}junaid-shaikh.vcf" class="contact-btn">Save Contact</a>
                  <!-- <button id="downloadButtonNormal" [vcdDownloadVCard]="vCard" [encoding]="vCardEncoding.none" class="contact-btn">
                    Save Contact
                  </button> -->
                  <p> <a href="/"> <img src="{{baseURl}}images/website.svg" alt="Top creative agencies in dubai" width="35" height="" loading="lazy"> </a></p>
                  <p> <a href="https://www.linkedin.com/in/junaid-nour-56515493" target="_blank"> <img
                        src="{{baseURl}}images/linkedin.svg" alt="graphic design company" width="35" height="" loading="lazy"> </a></p>
                        <p> <a href="https://instagram.com/junaidnour?igshid=YmMyMTA2M2Y=" target="_blank"> <img
                          src="{{baseURl}}images/instagram.svg" alt="website developers in dubai" width="35" height="" loading="lazy"></a></p>
                 
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</section>